export const MIN_RATE = 0.25;
export const MAX_RATE = 2;
export const RATE_STEP = 0.25;
export const MINIMUM_NET_WORTH_TO_PROCEED = 200000;

export const PROCEED_RULE_MESSAGE =
  'Este cliente não possui patrimônio elegível para o modelo Fee Fixo.';
export const OVERWRITE_TERM_NOTICE_MESSAGE =
  'Ao continuar a substituição, o termo atual será substituído pelo novo.';

export const OVERWRITE_TERM_RESTRICTED_NOTICE_MESSAGE =
  'Este cliente já possui um termo que não pode ser substituído.';
